import React from 'react';
import { Card } from '../components/ui/Card';
import { Button } from '../components/ui/Button';
import { Link } from 'react-router-dom';
import { UsersIcon, BriefcaseIcon, CheckIcon, StarIcon, CheckCircleIcon, ArrowRightIcon } from 'lucide-react';
const Teams = () => {
  // Mock teams data
  const teams = [{
    id: 1,
    name: 'WebTech Solutions',
    logo: 'https://via.placeholder.com/100?text=WTS',
    description: 'Full-stack development team specializing in Laravel and Vue.js applications.',
    members: 8,
    location: 'San Francisco, CA',
    projects: 45,
    services: ['Web Development', 'API Integration', 'E-commerce']
  }, {
    id: 2,
    name: 'DevOps Ninjas',
    logo: 'https://via.placeholder.com/100?text=DN',
    description: 'Expert team focused on DevOps, CI/CD pipelines, and cloud infrastructure for Laravel apps.',
    members: 5,
    location: 'London, UK',
    projects: 32,
    services: ['DevOps', 'AWS', 'Docker', 'CI/CD']
  }, {
    id: 3,
    name: 'UX Wizards',
    logo: 'https://via.placeholder.com/100?text=UXW',
    description: 'Design and development team creating beautiful, user-friendly Laravel applications.',
    members: 12,
    location: 'Berlin, Germany',
    projects: 78,
    services: ['UI/UX Design', 'Frontend Development', 'User Testing']
  }, {
    id: 4,
    name: 'Data Masters',
    logo: 'https://via.placeholder.com/100?text=DM',
    description: 'Specialized in data-heavy Laravel applications, analytics, and reporting solutions.',
    members: 7,
    location: 'Toronto, Canada',
    projects: 29,
    services: ['Data Analytics', 'Reporting Systems', 'Database Optimization']
  }];
  return <div className="bg-[#0F1115] min-h-screen text-gray-300 relative" data-id="element-1652">
      {/* Global Grain Texture */}
      <div className="absolute inset-0 opacity-[0.03] pointer-events-none z-50 bg-grain mix-blend-overlay" data-id="element-1653"></div>

      {/* Hero Section */}
      <section className="relative bg-gradient-to-br from-[#0F1115] via-[#1a1d24] to-[#111827] text-white overflow-hidden" data-id="element-1654">
        {/* Subtle grain texture */}
        <div className="absolute inset-0 opacity-[0.015] bg-grain" data-id="element-1655"></div>

        {/* Animated background elements */}
        <div className="absolute inset-0 overflow-hidden pointer-events-none" data-id="element-1656">
          <div className="absolute top-20 left-10 w-72 h-72 bg-gradient-to-br from-[#d73b3e]/10 to-transparent rounded-full blur-3xl" data-id="element-1657" />
          <div className="absolute bottom-20 right-10 w-96 h-96 bg-gradient-to-br from-orange-500/10 to-transparent rounded-full blur-3xl" data-id="element-1658" />
        </div>

        <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-20 lg:py-28 relative z-10" data-id="element-1659">
          <div className="max-w-4xl mx-auto text-center" data-id="element-1660">
            <div className="inline-flex items-center gap-2 px-4 py-2 bg-white/10 backdrop-blur-sm rounded-full border border-white/20 mb-6" data-id="element-1661">
              <UsersIcon className="w-4 h-4 text-[#d73b3e]" data-id="element-1662" />
              <span className="text-sm font-medium" data-id="element-1663">
                {teams.length}+ Expert Teams
              </span>
            </div>

            <h1 className="font-display text-5xl lg:text-6xl font-bold mb-6 leading-tight tracking-tight" data-id="element-1664">
              Find expert{' '}
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#d73b3e] to-orange-500" data-id="element-1665">
                Laravel teams
              </span>
            </h1>

            <p className="text-xl lg:text-2xl text-gray-300 mb-10 leading-relaxed" data-id="element-1666">
              Connect with agencies and development teams specialized in Laravel
              projects
            </p>

            <Link to="#teams" className="inline-block px-8 py-4 bg-[#d73b3e] text-white rounded-full font-semibold text-lg hover:bg-[#c02f32] transition-all duration-300 shadow-lg hover:shadow-xl" data-id="element-1667">
              Browse Teams
            </Link>

            {/* Trust indicators */}
            <div className="flex flex-wrap justify-center gap-8 text-sm text-gray-400 mt-8" data-id="element-1668">
              <div className="flex items-center gap-2" data-id="element-1669">
                <CheckCircleIcon className="h-5 w-5 text-green-400" data-id="element-1670" />
                <span data-id="element-1671">Verified development teams</span>
              </div>
              <div className="flex items-center gap-2" data-id="element-1672">
                <CheckCircleIcon className="h-5 w-5 text-green-400" data-id="element-1673" />
                <span data-id="element-1674">200+ successful projects</span>
              </div>
            </div>
          </div>
        </div>

        {/* Curved divider */}
        <div className="absolute bottom-0 left-0 right-0" data-id="element-1675">
          <svg viewBox="0 0 1440 120" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full" data-id="element-1676">
            <path d="M0 120L60 105C120 90 240 60 360 45C480 30 600 30 720 37.5C840 45 960 60 1080 67.5C1200 75 1320 75 1380 75L1440 75V120H1380C1320 120 1200 120 1080 120C960 120 840 120 720 120C600 120 480 120 360 120C240 120 120 120 60 120H0Z" fill="#0F1115" data-id="element-1677" />
          </svg>
        </div>
      </section>

      {/* Teams List */}
      <section className="py-16 relative z-10" id="teams" data-id="element-1678">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1679">
          <div className="grid md:grid-cols-2 gap-8" data-id="element-1680">
            {teams.map(team => <div key={team.id} className="bg-[#1a1d24] rounded-2xl border border-gray-800 p-6 hover:border-gray-700 transition-all duration-300" data-id="element-1681">
                <div className="flex items-start" data-id="element-1682">
                  <div className="w-16 h-16 bg-white/5 rounded-xl flex items-center justify-center overflow-hidden border border-gray-800" data-id="element-1683">
                    <img src={team.logo} alt={team.name} className="w-full h-full object-cover" data-id="element-1684" />
                  </div>
                  <div className="ml-4 flex-1" data-id="element-1685">
                    <h3 className="text-xl font-semibold text-white" data-id="element-1686">
                      {team.name}
                    </h3>
                    <div className="flex items-center text-sm text-gray-400 mt-1" data-id="element-1687">
                      <UsersIcon className="h-4 w-4 mr-1.5 text-gray-500" data-id="element-1688" />
                      {team.members} team members
                      <span className="mx-2" data-id="element-1689">•</span>
                      {team.location}
                    </div>
                  </div>
                </div>

                <p className="mt-4 text-gray-400 leading-relaxed" data-id="element-1690">
                  {team.description}
                </p>

                <div className="mt-4" data-id="element-1691">
                  <div className="text-sm font-medium text-gray-300 mb-2" data-id="element-1692">
                    Services:
                  </div>
                  <div className="flex flex-wrap gap-2" data-id="element-1693">
                    {team.services.map((service, index) => <span key={index} className="bg-white/5 text-gray-300 text-xs px-3 py-1.5 rounded-full border border-gray-800" data-id="element-1694">
                        {service}
                      </span>)}
                  </div>
                </div>

                <div className="mt-6 pt-4 border-t border-gray-800 flex items-center justify-between" data-id="element-1695">
                  <div className="flex items-center text-sm text-gray-400" data-id="element-1696">
                    <BriefcaseIcon className="h-4 w-4 mr-1.5 text-gray-500" data-id="element-1697" />
                    {team.projects} projects completed
                  </div>
                  <button className="px-4 py-2 bg-white/5 text-white rounded-full text-sm font-medium hover:bg-white/10 transition-all duration-300 border border-gray-800" data-id="element-1698">
                    View Profile
                  </button>
                </div>
              </div>)}
          </div>
        </div>
      </section>

      {/* Why Choose a Team Section */}
      <section className="py-20 bg-gradient-to-br from-[#1a1d24] to-[#0F1115] relative z-10" data-id="element-1699">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1700">
          <div className="max-w-3xl mx-auto text-center mb-16" data-id="element-1701">
            <h2 className="text-3xl md:text-4xl font-bold mb-4 leading-tight" data-id="element-1702">
              Why choose a{' '}
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#d73b3e] to-orange-500" data-id="element-1703">
                development team?
              </span>
            </h2>
            <p className="text-lg text-gray-400" data-id="element-1704">
              Development teams offer comprehensive solutions for complex
              projects
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-8" data-id="element-1705">
            <div className="bg-[#1a1d24] p-8 rounded-2xl shadow-lg border border-gray-800 hover:border-gray-700 transition-colors" data-id="element-1706">
              <div className="w-14 h-14 bg-gradient-to-br from-[#d73b3e]/10 to-orange-500/10 rounded-2xl flex items-center justify-center mb-6 border border-white/5" data-id="element-1707">
                <UsersIcon className="h-7 w-7 text-[#d73b3e]" data-id="element-1708" />
              </div>
              <h3 className="text-xl font-semibold mb-3 text-white" data-id="element-1709">
                Diverse Expertise
              </h3>
              <p className="text-gray-400 leading-relaxed" data-id="element-1710">
                Access a range of specialists including designers, developers,
                and QA engineers all working together.
              </p>
            </div>

            <div className="bg-[#1a1d24] p-8 rounded-2xl shadow-lg border border-gray-800 hover:border-gray-700 transition-colors" data-id="element-1711">
              <div className="w-14 h-14 bg-gradient-to-br from-[#d73b3e]/10 to-orange-500/10 rounded-2xl flex items-center justify-center mb-6 border border-white/5" data-id="element-1712">
                <CheckIcon className="h-7 w-7 text-[#d73b3e]" data-id="element-1713" />
              </div>
              <h3 className="text-xl font-semibold mb-3 text-white" data-id="element-1714">
                Proven Processes
              </h3>
              <p className="text-gray-400 leading-relaxed" data-id="element-1715">
                Benefit from established workflows, code reviews, and quality
                assurance procedures.
              </p>
            </div>

            <div className="bg-[#1a1d24] p-8 rounded-2xl shadow-lg border border-gray-800 hover:border-gray-700 transition-colors" data-id="element-1716">
              <div className="w-14 h-14 bg-gradient-to-br from-[#d73b3e]/10 to-orange-500/10 rounded-2xl flex items-center justify-center mb-6 border border-white/5" data-id="element-1717">
                <StarIcon className="h-7 w-7 text-[#d73b3e]" data-id="element-1718" />
              </div>
              <h3 className="text-xl font-semibold mb-3 text-white" data-id="element-1719">
                End-to-End Service
              </h3>
              <p className="text-gray-400 leading-relaxed" data-id="element-1720">
                Get comprehensive project management from planning and design
                through development and launch.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-gradient-to-br from-gray-900 to-black text-white border-t border-gray-800 relative z-10" data-id="element-1721">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1722">
          <div className="max-w-3xl mx-auto text-center" data-id="element-1723">
            <h2 className="text-3xl md:text-4xl font-bold mb-6 leading-tight" data-id="element-1724">
              Need a team for your{' '}
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#d73b3e] to-orange-500" data-id="element-1725">
                project?
              </span>
            </h2>
            <p className="text-xl text-gray-300 mb-10" data-id="element-1726">
              Post your project requirements and get matched with the right team
            </p>
            <div className="flex flex-col sm:flex-row justify-center gap-4" data-id="element-1727">
              <Link to="/post-job" className="px-8 py-4 bg-[#d73b3e] text-white rounded-full font-semibold text-lg hover:bg-[#c02f32] transition-all duration-300 shadow-lg hover:shadow-xl" data-id="element-1728">
                Post a Project
              </Link>
              <Link to="/developers" className="px-8 py-4 bg-white/10 backdrop-blur-sm text-white rounded-full font-semibold text-lg hover:bg-white/20 transition-all duration-300 border-2 border-white/20" data-id="element-1729">
                Browse Developers
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>;
};
export default Teams;